import * as $ from "jquery";
import { C } from "../common/component";
import { TimesheetLeftTableData } from "./timesheet-models";
import { EditableTableCalculator } from "../common/editable-table";
import { Displayer } from "../common/displayer";
import { Helper } from "../common/helper";

export class TimesheetLeftTable
{
    private readonly leftTable: any;
    private readonly width: number;
    private readonly headerRow;
    private leftColumn: any;

    constructor(leftTable: TimesheetLeftTableData, width: number, isCompact: boolean, baseRowHeight: number,
                calculator: EditableTableCalculator)
    {
        this.initDragScroll();

        this.width = width;
        this.leftTable = C.table.addClass("table table-bordered table-sm schedule-table");
        const leftBody = C.tbody;

        const header = C.thead.appendTo(this.leftTable);
        this.headerRow = C.tr.css("height", "27px").appendTo(header);
        let titleColspan = 0;
        for (const column of leftTable.Columns)
        {
            titleColspan += column.Colspan;
        }
        const titleCell = C.th.attr("colspan", titleColspan).attr("nowrap", "nowrap").appendTo(this.headerRow);
        titleCell.text(leftTable.Title);
        titleCell.attr("data-container", "body").attr("title", leftTable.TitleTooltip).tooltip();

        this.headerRow = C.tr.addClass("header-row").appendTo(header);
        for (const column of leftTable.Columns)
        {
            const headerCell = C.th.text(column.DisplayName).attr("colspan", column.Colspan).appendTo(this.headerRow);
            if (isCompact)
            {
                headerCell.attr("title", column.DisplayName).css("max-width", "50px").css("overflow-x", "hidden");
            }
            if (column.Tooltip)
            {
                headerCell.attr("data-container", "body").attr("title", column.Tooltip).tooltip();
            }
        }
        // HACK: Unfortunately the idiots who designed css could not see that somebody may want to use min-height property with something
        // else than div, which means we have to add this stupid and completely unnecessary div here, to force min-height to our header row
        C.div.css("width", "0").css("min-height", "72px").appendTo(this.headerRow);
        leftBody.appendTo(this.leftTable);

        for (const rowData of leftTable.Rows)
        {
            const row = C.tr.addClass("left-body-row").height(rowData.RowHeightMultiplier * baseRowHeight).appendTo(leftBody);
            for (const cellData of rowData.Cells)
            {
                const cell = C.td.css("white-space", "nowrap").attr("rowspan", cellData.Rowspan).appendTo(row);
                if (isCompact)
                {
                    cell.css("max-width", "100px").css("overflow-x", "hidden");
                }
                if (cellData.Value)
                {
                    Displayer.setValue(cell, cellData.Value, null, false, true);
                }
                else
                {
                    calculator.addCell(cell, cellData);
                }
            }
        }
    }

    appendTo(parent)
    {
        this.leftColumn = Helper.isMobileScreen()
            ? C.div
                .addClass("left-table schedule-col table-responsive schedule-border")
                .css({
                    minWidth: "1px",
                    maxWidth: "1px",
                    overflow: "hidden"
                })
            : C.div
                .addClass(`left-table col-xs-${this.width} schedule-col table-responsive schedule-border`);

        this.leftTable.appendTo(this.leftColumn.appendTo(parent));

        C.div.css("height", "17px").appendTo(this.leftColumn); // scrollbar spacing
    }

    getHeaderHeight()
    {
        return this.headerRow.height();
    }

    setFixedHeader() {
        if (Helper.isMobileScreen()) {
            return;
        }

        const fullClone = this.leftTable.clone();
        fullClone.css("margin-bottom", "0");

        const headerClone = C.div.css({
            "overflow": "hidden",
            "background": "white",
            "z-index": "100",
            "display": "none",
            "border-bottom": "2px solid #ddd"
        }).append(fullClone);

        this.leftColumn.css("position", "relative");
        headerClone.appendTo(this.leftColumn);

        const syncHeight = () => {
            const headerHeight = this.leftTable.find("thead").outerHeight();
            headerClone.css("height", headerHeight + "px");
        };

        let synced = false;

        C.window.on("scroll.timesheetLeftHeader", () => {
            const scrollTop = C.window.scrollTop();
            const tableTop = this.leftColumn.offset().top;
            const tableBottom = this.leftColumn.offset().top + this.leftColumn.height();

            if (scrollTop >= tableTop && scrollTop < tableBottom) {
                if (!synced) {
                    syncHeight();
                    synced = true;
                }
                const borderLeft = parseFloat(getComputedStyle(this.leftColumn[0]).borderLeftWidth) || 0;
                headerClone.css({
                    "display": "block",
                    "position": "fixed",
                    "top": "0",
                    "left": (this.leftColumn[0].getBoundingClientRect().left + borderLeft) + "px",
                    "width": this.leftColumn[0].clientWidth + "px"
                });
            } else {
                headerClone.css("display", "none");
            }
        });

        C.window.on("resize.timesheetLeftHeader", () => {
            synced = false;
        });
    }

    destroy() {
        C.window.off("scroll.timesheetLeftHeader");
        C.window.off("resize.timesheetLeftHeader");
    }

    private initDragScroll()
    {
        $.fn.dragScroll = function ()
        {
            let attachment = false, lastPosition, position, difference;
            C.window.on("mouseup", function ()
            {
                attachment = false;
            });
            return C.create(this).css("cursor", "move").css("user-select", "none").on("mousedown mouseup mousemove",
                function (e)
                {
                    if (e.type === "mousedown")
                    {
                        attachment = true, lastPosition = [e.clientX, e.clientY];
                    }
                    if (e.type === "mouseup")
                    {
                        attachment = false;
                    }
                    if (e.type === "mousemove" && attachment === true)
                    {
                        position = [e.clientX, e.clientY];
                        difference = [(position[0] - lastPosition[0]), (position[1] - lastPosition[1])];
                        C.create(this).scrollLeft(C.create(this).scrollLeft() - difference[0]);
                        C.create(this).scrollTop(C.create(this).scrollTop() - difference[1]);
                        lastPosition = [e.clientX, e.clientY];
                    }
                });
        };
    }
}

